/**
 * Logs de depuración: solo en desarrollo (Vite). En producción no escribe en consola.
 * No sustituye console.error / console.warn para trazas operativas.
 */
export function devLog(...args) {
  if (import.meta.env.DEV) {
    console.log(...args);
  }
}

/**
 * Diagnóstico Asuntos V1 + historial: activar con
 * `localStorage.setItem('ARCHAT_DEBUG_SUBJECT_MESSAGES', '1')` y recargar.
 */
export function isArchatDebugSubjectMessages() {
  try {
    return typeof localStorage !== 'undefined' && localStorage.getItem('ARCHAT_DEBUG_SUBJECT_MESSAGES') === '1';
  } catch {
    return false;
  }
}

/**
 * Orden cronológico de mensajes en UI/store: activar con
 * `localStorage.setItem('ARCHAT_DEBUG_MESSAGE_ORDER', '1')` y recargar.
 */
export function isArchatDebugMessageOrder() {
  try {
    return typeof localStorage !== 'undefined' && localStorage.getItem('ARCHAT_DEBUG_MESSAGE_ORDER') === '1';
  } catch {
    return false;
  }
}
